import { useQuery } from '@tanstack/react-query';
import IncidentReportsDrafts from '../../views/IncidentReportsDrafts';
import { GetIncidentByIdResponse } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import Loader from '../../components/Loader';

export default function IncidentReportsDraftsPage() {
  const { IncidentReportingApi } = useApiClients();
  const {
    data = [],
    isLoading,
    isRefetching,
  } = useQuery<GetIncidentByIdResponse['incident'][]>({
    queryKey: ['all-drafts'],
    queryFn: async () => {
      const response =
        await IncidentReportingApi.incidentReportingControllerGetDrafts();
      return response?.data?.incidents;
    },
  });

  if (isLoading || isRefetching) {
    return <Loader />;
  }

  return (
    <>
      <IncidentReportsDrafts draftIncidents={data} />
    </>
  );
}
